module.exports = __webpack_public_path__ + "img/extended.87331ca8.png";